/* eslint-disable no-undef */
import React from 'react'


import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, bool, func, arrayOf, object,
} from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import InputWithPostfix from 'Pods/Shared/InputWithPostfix'
import RichEditor from 'Pods/Shared/RichEditor/RichEditor'
import TagsInputField from 'Pods/Shared/TagsInputField'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const helpIcon = <Icon type={['fas', 'question-circle']} color="grey" className="info-icon ml-5" />

function DetailsArea({
  isPrintable,
  isLowPoly,
  title = '',
  description = '',
  tags = EMPTY_ARRAY,
  recommendedTags = EMPTY_ARRAY,
  showTagsTip,
  showErrors,
  onTagsChange,
  handleInputChange,
  handleInputBlur,
  handleEditorChange,
  errorFor,
  tagsInputRef,
}) {
  function getAnnex() {
    if (isPrintable) {
      return '3D print model'
    }

    if (isLowPoly) {
      return 'low-poly 3D model'
    }

    return '3D model'
  }

  return (
    <div className="publisher-area publisher-area--details">
      <div className="card">
        <div className="l-inner">
          <div className="section-heading">Details</div>
          <InputWithPostfix
            label="Title"
            id="title"
            name="title"
            required
            simpleError
            customLabelInfo={(
              <Tooltip id="label-info-title" content={I18n.translate('tooltips.publisher.title')}>
                {helpIcon}
              </Tooltip>
            )}
            errorText={errorFor('title')}
            showError={showErrors}
            value={title}
            formClassName="form-group-grey"
            inputClassName="form-control-grey"
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            postfix={getAnnex()}
          />

          <RichEditor
            label="Description"
            required
            customMoreInfo={(
              <Tooltip id="label-info-description" content={I18n.translate('tooltips.publisher.description')}>
                {helpIcon}
              </Tooltip>
            )}
            value={description}
            onChange={handleEditorChange}
            showError={showErrors}
            errorText={errorFor('description')}
            onBlur={handleInputBlur}
          />

          <TagsInputField
            ref={tagsInputRef}
            id="tags"
            label="Tags"
            required
            customMoreInfo={(
              <Tooltip id="label-info-tags" content={I18n.translate('tooltips.publisher.tags')}>
                {helpIcon}
              </Tooltip>
            )}
            value={tags}
            formClassName="tags-input"
            onChange={onTagsChange}
            recommendedTags={recommendedTags}
            max={20}
            errorText={errorFor('tags')}
            showError={showErrors}
          />

          {showTagsTip && (
            <small className="text-default">
              <i>Tip: Upload model images or start typing tags to get recommended tags</i>
            </small>
          )}
        </div>
      </div>
    </div>
  )
}

DetailsArea.propTypes = {
  isPrintable: bool.isRequired,
  isLowPoly: bool.isRequired,
  title: string,
  description: string,
  tags: arrayOf(string),
  recommendedTags: arrayOf(string),
  showTagsTip: bool.isRequired,
  showErrors: bool.isRequired,
  onTagsChange: func.isRequired,
  handleInputChange: func.isRequired,
  handleInputBlur: func.isRequired,
  handleEditorChange: func.isRequired,
  errorFor: func.isRequired,
  tagsInputRef: object.isRequired,
}

export default DetailsArea
